import * as React from 'react';
import { useDispatch } from 'react-redux';

import { toggleStickyScrollBtn } from '../../../actions/page/toggleStickyScrollBtn';

type TContainerRef = React.RefObject<HTMLDivElement>;

/** хук проверяет находится ли элемент выше текущего вьюпорта и переключает видимость кнопки */
export function useToggleStickyScrollBtn(containerRef: TContainerRef) {
  const dispatch = useDispatch();

  const checkIsElementOutOfViewport = React.useCallback(() => {
    const filtersContainer = containerRef.current;
    if (filtersContainer) {
      if (filtersContainer.getBoundingClientRect().bottom < 0) {
        dispatch(toggleStickyScrollBtn(true));
      } else {
        dispatch(toggleStickyScrollBtn(false));
      }
    }
  }, [containerRef, dispatch]);

  React.useEffect(() => {
    window.addEventListener('scroll', checkIsElementOutOfViewport);

    return () => window.removeEventListener('scroll', checkIsElementOutOfViewport);
  }, [checkIsElementOutOfViewport]);
}
